/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KoreaStockOutboundOrderStatisticsVo } from './KoreaStockOutboundOrderStatisticsVo';
import {
    KoreaStockOutboundOrderStatisticsVoFromJSON,
    KoreaStockOutboundOrderStatisticsVoFromJSONTyped,
    KoreaStockOutboundOrderStatisticsVoToJSON,
    KoreaStockOutboundOrderStatisticsVoToJSONTyped,
} from './KoreaStockOutboundOrderStatisticsVo';

/**
 * 
 * @export
 * @interface ResponseKoreaStockOutboundOrderStatisticsVo
 */
export interface ResponseKoreaStockOutboundOrderStatisticsVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseKoreaStockOutboundOrderStatisticsVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseKoreaStockOutboundOrderStatisticsVo
     */
    message?: string;
    /**
     * 
     * @type {KoreaStockOutboundOrderStatisticsVo}
     * @memberof ResponseKoreaStockOutboundOrderStatisticsVo
     */
    data?: KoreaStockOutboundOrderStatisticsVo;
}

/**
 * Check if a given object implements the ResponseKoreaStockOutboundOrderStatisticsVo interface.
 */
export function instanceOfResponseKoreaStockOutboundOrderStatisticsVo(value: object): value is ResponseKoreaStockOutboundOrderStatisticsVo {
    return true;
}

export function ResponseKoreaStockOutboundOrderStatisticsVoFromJSON(json: any): ResponseKoreaStockOutboundOrderStatisticsVo {
    return ResponseKoreaStockOutboundOrderStatisticsVoFromJSONTyped(json, false);
}

export function ResponseKoreaStockOutboundOrderStatisticsVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseKoreaStockOutboundOrderStatisticsVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : KoreaStockOutboundOrderStatisticsVoFromJSON(json['data']),
    };
}

export function ResponseKoreaStockOutboundOrderStatisticsVoToJSON(json: any): ResponseKoreaStockOutboundOrderStatisticsVo {
    return ResponseKoreaStockOutboundOrderStatisticsVoToJSONTyped(json, false);
}

export function ResponseKoreaStockOutboundOrderStatisticsVoToJSONTyped(value?: ResponseKoreaStockOutboundOrderStatisticsVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': KoreaStockOutboundOrderStatisticsVoToJSON(value['data']),
    };
}

